var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/~/core-js/library/modules/_core.js
// module id = 32
// module chunks = 0